import React from 'react';
import IPBSView from './IPBSView';

const createIPBSAdapter = (soid) => {
  return () => <IPBSView serviceOfferingId={soid} />;
};

export default createIPBSAdapter;
